import login, { LoginReducer } from './login';

export type Reducer = {
  login: LoginReducer;
};

export default window.redux.combineReducers({ login });
